<div class="modal-content">
  <div class="modal-header">
    <h3 class="modal-title" id="myExtraLargeModalLabel">
      <ng-container>
        Bulk Terminal Configuration
      </ng-container>
    </h3>
    <button type="button" class="close" (click)="close()">×</button>
  </div>
  <div class="modal-body">

    <div class="row" *ngIf="raiseDanger">
      <div class="col-md-12 form-horizontal px-3">
        <ngb-alert type="danger" [dismissible]="false">
          <strong>Error!</strong> {{danger}}
        </ngb-alert>
      </div>
    </div>
    <div class="row">
      <div class="form-group row" *ngIf="success" style="width:100%;">
        <div class="col-md-12 form-horizontal px-6" style="width:100%;">
          <ngb-alert type="info" [dismissible]="false" style="width:100%;">
            <strong></strong> {{message}}
          </ngb-alert>
        </div>
      </div>
    </div>

    <form [formGroup]="TerminalFormGroup" role="form" autocomplete="off">

      <div class="row form-horizontal">
        <div class="col-md-6 form-horizontal px-3">

          <h4>Merchant summary.</h4>
          <hr />
          <br />
          <div class="form-group row">
            <div class="col-12">
              <label class="col-12 col-form-label"><b>Merchant number: </b></label>
              <input disabled class="form-control" formControlName="merchantNumber" style="margin-left:5px;" value="{{terminalSignUp[0]?.merchantNumber}}" />
            </div>
          </div>
          <div class="form-group row">
            <div class="col-12">
              <label class="col-12 col-form-label"><b>Merchant name : </b></label>
              <input disabled class="form-control" formControlName="shopName" style="margin-left:5px;" value="{{merchantSignUp?.shopName}}" />
            </div>
          </div>
          <div class="form-group row">
            <div class="col-12">
              <label class="col-12 col-form-label"><b>Terminal(s) were requested by : </b></label>
              <input disabled class="form-control" style="margin-left:5px;" value="{{terminalSignUp[0]?.changedBy}} on {{terminalSignUp[0]?.changedOn | date}}" />
            </div>
          </div>
          <div class="form-group row">
            <div class="col-12">
              <label class="col-12 col-form-label"><b>Terminal(s) are being prepared by :</b></label>
              <input disabled class="form-control" style="margin-left:5px;" value="{{terminalSignUp[0]?.inUseBy}}" />
            </div>
          </div>
          <div class="form-group row">
            <div class="col-12">
              <label class="col-12 col-form-label"><b>Last interaction date :</b></label>
              <input disabled class="form-control" style="margin-left:5px;" value=" {{terminalSignUp[0]?.inUseDate | date}}" />
            </div>
          </div>
          <div class="form-group row">
            <div class="col-12">
              <label class="col-12 col-form-label"><b>Total terminals in preparation :</b></label>
              <input disabled class="form-control" style="margin-left:5px;" value="{{terminalSignUp?.length}}" />
            </div>
          </div>
          <div class="form-group row">
            <div class="col-12">
              <label class="col-12 col-form-label"><b>Delivery method :</b></label>
              <input disabled class="form-control" style="margin-left:5px;" value="{{terminalSignUp[0]?.deliveryMethod}}" />
            </div>
          </div>

          <div class="form-group row">
            <div class="col-12">
              <label class="col-12 col-form-label"><b>Retail :</b></label>
              <textarea rows="4" disabled class="form-control" [value]="terminalSignUp[0]?.retail">
              </textarea>
            </div>
          </div>

          <div class="form-group row">
            <div class="col-12">
              <label class="col-12 col-form-label"><b>Admin :</b></label>
              <textarea rows="4" disabled class="form-control" [value]="terminalSignUp[0]?.admin">
              </textarea>
            </div>
          </div>

          <div class="form-group row" *ngIf="client">
            <div class="col-12">
              <label for="NoteFC" class="col-4 col-form-label">Add a note</label>

              <textarea rows="4" cols="24" formControlName="notesFC" class="form-control" id="notesFC" placeholder="Notes"></textarea>
              <br />
              <button type="button"
                      class="btn btn-info waves-effect waves-light"
                      (click)="SaveNote()">
                Save note
              </button>
              <br />

            </div>
          </div>
          <div class="form-group row">
            <div class="col-12">
              <button type="button" class="btn btn-info waves-effect waves-light"
                      (click)="viewNotes()">
                View notes
              </button>
            </div>
          </div>


        </div>
        <div class="col-md-6 form-horizontal px-3">
          <h4>Terminal summary.</h4>
          <hr />
          <br />

          <div formArrayName="terminals" *ngFor="let terms of allTerminals.controls; let i = index">
            <div [formGroupName]="i">

              <div class="form-group row">
                <label for="terminalId" class="col-4 col-form-label">Terminal Id</label>
                <div class="col-8">
                  <input formControlName="terminalId" class="form-control" id="terminalId" placeholder="Terminal Id" maxlength="8">
                </div>
              </div>

              <div class="form-group row">
                <label for="terminalId" class="col-4 col-form-label">Make</label>
                <div class="col-8">
                  <input formControlName="terminalMake" class="form-control" id="terminalMake" placeholder="Make">
                </div>
              </div>

              <div class="form-group row">
                <label for="terminalId" class="col-4 col-form-label">Model</label>
                <div class="col-8">
                  <input formControlName="terminalModel" class="form-control" id="terminalModel" placeholder="Model">
                </div>
              </div>

              <div class="form-group row">
                <label for="serialNumber" class="col-4 col-form-label">Serial number<i class="asterisk-acs" ngbTooltip="Serial number is required"> *</i></label>
                <div class="col-8">
                  <input formControlName="serialNumber" class="form-control" id="serialNumber" placeholder="Serial number" />
                </div>
              </div>

              <div class="form-group row">
                <label for="simNumber" class="col-4 col-form-label">Sim number<i class="asterisk-acs" ngbTooltip="Sim number is required"> *</i></label>
                <div class="col-8">
                  <input formControlName="simNumber" class="form-control" id="simNumber" placeholder="Sim number" />
                </div>
              </div>

              <div class="form-group row">
                <label for="baseSerialNumber" class="col-4 col-form-label">Base Serial number</label>
                <div class="col-8">
                  <input formControlName="baseSerialNumber" class="form-control" id="baseSerialNumber" placeholder="Base serial number" />
                </div>
              </div>

              <div class="fc-divider dropdown-divider" style="border: 1px solid #477c93"></div>
            </div>
          </div>
          <div class="form-group row" *ngIf="confirm">
            <div class="col-12">
              <br />
              <input formControlName="dispatch" style="display:inline;width: 10%; color:red" type="checkbox" id="dispatch" placeholder="Dispatch" /> <b style="color: red">By selecting this checkbox, you acknowledge that Aramex will be notified about the terminal(s).</b>
            </div>
          </div>
          <div class="form-group row" *ngIf="ticketOwner">
            <div class="col-12">
              <button type="button" *ngIf="enableButtonSave"
                      class="btn btn-info waves-effect waves-light fa-pull-right"
                      (click)="save()">
                Save & Close
              </button>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-12">
              <ngb-alert *ngIf="redirect" type="info" [dismissible]="false" style="width:100%;">
                <strong>Redirecting in : {{ remainingCount$ | async }} </strong>
              </ngb-alert>
            </div>
          </div>


        </div>

      </div>

    </form>

  </div>
</div>
